import React from 'react';

import './LoadingSpinner.css';

const LoadingSpinner = (props) => {
  return (
    <div className={`${props.asOverlay && 'loading-spinner__overlay'}`}>
      <div role="status" aria-label="Loading" className="lds-dual-ring"></div>
    </div>
  );
};

export default LoadingSpinner;
